import WordIcon from "@/images/new-doc-icon.svg?react";
import PdfIcon from "@/images/new-pdf-icon.svg?react";

export function DocumentIcon({ extension }: { extension: string | undefined }) {
  if (!!extension && ["docx", "doc"].includes(extension)) {
    return <WordIcon className="fs-2 text-primary" />;
  }
  return <PdfIcon className="fs-2 text-danger" />;
}
